var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubeShape02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.045 43.7306L22.8413 45.2174L47.8721 29.1724L41.0764 27.6852L16.045 43.7306Z",
    fill: "url(#paint0_linear_173_80)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.045 43.7306L22.8413 45.2174L47.8721 29.1724L41.0764 27.6852L16.045 43.7306Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0314 2.65437L31.8267 4.14092L47.8721 29.1723L41.0764 27.6851L25.0314 2.65437Z",
    fill: "url(#paint1_linear_173_80)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0314 2.65437L31.8267 4.14092L47.8721 29.1723L41.0764 27.6851L25.0314 2.65437Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0459 43.7307L41.0767 27.6858L25.0317 2.65503L0.00096414 18.7L16.0459 43.7307Z",
    fill: "url(#paint2_linear_173_80)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_80",
    x1: 36.5752,
    y1: 37.4612,
    x2: 20.3468,
    y2: 33.9116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_80",
    x1: 38.124,
    y1: 8.26689,
    x2: 33.4816,
    y2: 29.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_80",
    x1: 14.8414,
    y1: 14.3039,
    x2: 28.0185,
    y2: 34.8607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeShape02);
export default __webpack_public_path__ + "static/media/cubeShape02.ba09e2fd273602e79c6650beb528b375.svg";
export { ForwardRef as ReactComponent };